export default __webpack_public_path__ + "static/media/photo 3.6f366441.jpg";